<div class={`week ${day <= today && 'lived'}`}></div>

<script>
	export let day;
	let today = new Date();
</script>

<style>
	.week {
		position: relative;
		width: 8px;
		height: 8px;
		margin: -1px -1px 0 0;
		border: 1px solid #bbb;
		/* border-style: dotted; */
		background-color: white;
	}

	.lived:after {
		content: "";
		display: block;
		position: absolute;
		width: 4px;
		height: 4px;
		top: 2px;
		left: 2px;
		background-color: black;
	}
</style>
